import { render, staticRenderFns } from "./TableBGMesurement.vue?vue&type=template&id=6bbd29ae&scoped=true"
import script from "./TableBGMesurement.vue?vue&type=script&lang=js"
export * from "./TableBGMesurement.vue?vue&type=script&lang=js"
import style0 from "./TableBGMesurement.vue?vue&type=style&index=0&id=6bbd29ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd29ae",
  null
  
)

export default component.exports